module.exports = __webpack_public_path__ + "img/quiz_NS.a1c5e6de.svg";